import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Select,
  MenuItem,
  ListItemText,
  TextField
} from "@mui/material";

//inline styles
const InlineStyles = {
  TableHeader: {
    backgroundColor: "#262671",
    color: "white",
    position: "sticky",
    top: 0,
    zIndex: 1,
    height: "50px",
  },
  TableCells: {
    color: "black",
    fontSize: "12px",
    height: "44px",
    padding: "0px",
    width: "300px",
  },
  TableBodyRows: {
    border: "1px solid #ddd",
    marginTop: "10px",
    paddingTop: "15px",
    verticalAlign: "top",
  },
  TableBodyRowCells: {
    height: "20px",
    padding: "0px",
  },
  chaserIndicatorTableCell: {
    height: "30px",
    width: "200px",
    padding: "3px",
  },
  chaserIndicator: {
    position: "relative",
    width: "123px",
    height: "35px",
    minWidth: "200px",
    maxHeight: "35px"
  },
  MoreVertIconStyle: {
    color: "FF5A01",
    background: "transparent",
    cursor: "pointer",
    transform: "rotate(90deg)",
  },
};
export const AddChaserIndicatorDetails = ({
  // statuses,
  handleInputChange,
  row,
  viewMode,
  validationStatus,
  // usersList,
  // handleEscalationUserChange,
}) => {
  return (
    <Table>
      <TableHead style={InlineStyles.TableHeader}>
        <TableRow style={{ backgroundColor: "#FFC000" }}>
          <TableCell className="TableCell" style={InlineStyles.TableCells}>
            Green to Yellow Duration
          </TableCell>
          <TableCell className="TableCell" style={InlineStyles.TableCells}>
            Yellow to Red Duration
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow style={InlineStyles.TableBodyRows}>
          <TableCell sx={InlineStyles.chaserIndicatorTableCell}>
            <TextField
              value={row.green_to_yellow}
              onChange={(e) => handleInputChange('green_to_yellow', e.target.value)}
              sx={InlineStyles.chaserIndicator}
              size="small"
              placeholder='Enter Details Here'
              disabled={viewMode}
            /><br />
            {validationStatus?.green_to_yellow && (
              <span style={{ color: 'red' }}>{validationStatus?.green_to_yellow}</span>
            )}
          </TableCell>

          <TableCell sx={InlineStyles.chaserIndicatorTableCell}>
            <TextField
              value={row.yellow_to_red}
              onChange={(e) => handleInputChange('yellow_to_red', e.target.value)}
              sx={InlineStyles.chaserIndicator}
              size="small"
              placeholder='Enter Details Here'
              disabled={viewMode}
            /><br />
            {validationStatus?.yellow_to_red && (
              <span style={{ color: 'red' }}>{validationStatus?.yellow_to_red}</span>
            )}
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
};
